import * as config from '../config';
import { generateQueryParams, generateQueryParamsFromList } from '../assets/js/function-utils';

const ENDPOINTS = {
    GATEWAY: config.gateway_uri || 'https://apigateway.dev-cld.brasilseg.com.br',
    BASE_URL: !config.ambiente
        ? 'http://localhost:8090/simulador-patrimonio-rural'
        : config.gateway_uri + '/api/simulador-patrimonio-rural',
    CHAVE_SEGMAIS: (secret) => `/segmais/${secret}`,
    BROTO_COD_ACESSO: (brotoSecretId) => `/broto/${brotoSecretId}`,
    COTACAO: (chaveSegMais, chaveBroto) => `/cotacao?${generateQueryParams({ chaveSegMais, chaveBroto })}`,
    COBERTURAS: (codigoCotacao, idComboSelecionado) =>
        `/cobertura/buscar-por-codigo-cotacao/${codigoCotacao}?idComboSelecionado=${idComboSelecionado}`,
    PRODUTOS_VINCULADOS_CODIGO_ACESSO: (codigoAcesso) => `/codigo-acesso/produtos/${codigoAcesso}`,
    PRODUTOS_VINCULADOS_TIPO_COTACAO: (idTipoCotacao) => `/tipo-cotacao/produtos/${idTipoCotacao}`,
    ENVIO_EMAIL: (codigoCotacao, isSimulacao = true) =>
        `/email-pdf/${isSimulacao ? 'simulacao' : 'proposta'}/${codigoCotacao}`,
    AGENCIA: (agenciaId) => `/agencia-bancaria/${agenciaId}`,
    COMISSAO: (idTipoCotacao) => `/comissao?idTipoCotacao=${idTipoCotacao}`,
    COMISSAO_ESPECIAL: (codigoAcesso) => `/comissao/codigo-acesso?codigoAcesso=${codigoAcesso}`,
    CODIGO_ACESSO: (codigoAcesso) => `/codigo-acesso/${codigoAcesso}`,
    NOME_PARCEIRO: (codigoAcesso) => `/codigo-acesso/${codigoAcesso}/nome-parceiro`,
    CARREGAR_LISTA_BANCO: '/banco',
    COTACAO_ATUALIZAR: (codigoCotacao, chaveSegMais, chaveBroto) =>
        `/cotacao/${codigoCotacao}?${generateQueryParams({ chaveSegMais, chaveBroto })}`,
    SALVAR_RESULTADO_CALCULO: (codigoCotacao) => `/cotacao/${codigoCotacao}/salvar-calculo`,
    CALCULAR_COTACAO: (comLog, todosCombos) => `/cotacao/calcular?comLog=${comLog}&todosCombos=${todosCombos}`,
    BUSCAR_RELATORIO: (codigoCotacao, simulacao = true) =>
        `/cotacao/${codigoCotacao}/relatorio/${simulacao ? 'simulacao' : 'proposta'}`,
    VALIDAR_AGENCIA: (numAgencia) => `/agencia-bancaria/${numAgencia}/validar-agencia-bb`,
    GET_NOME_AGENCIA: (numAgencia) => `/agencia-bancaria/${numAgencia}`,
    SEND_DADOS_COMPLEMENTARES: (codigoCotacao) => `/cotacao/${codigoCotacao}/dados-complementares`,
    TIPO_COTACAO: (chaveSegMais) => `/tipo-cotacao?${generateQueryParams({ chaveSegMais })}`,
    TIPO_BEM: (idTipoCotacao, codigoAcesso, inGarantia) =>
        `/tipo-bem?idTipoCotacao=${idTipoCotacao}&${
            codigoAcesso ? 'codigoAcesso=' + codigoAcesso : ''
        }&inGarantia=${Boolean(inGarantia)}`,
    BENS: (idTipoBem, idTipoCotacao, codigoAcesso = null, inGarantia) =>
        `/tipo-bem/${idTipoBem}/bens?idTipoCotacao=${idTipoCotacao}${
            codigoAcesso ? '&codigoAcesso=' + codigoAcesso : ''
        }&inGarantia=${inGarantia}`,
    GET_FORMA_PAGAMENTO: (idTipoCotacao, codigoAcesso) =>
        `/pagamento?idTipoCotacao=${idTipoCotacao}&${codigoAcesso ? 'codigoAcesso=' + codigoAcesso : ''}`,
    GET_CEP: (cep) => `busca-cep/${cep}`,
    GET_QUESTIONARIO: (idTipoBem) => `/tipo-bem/${idTipoBem}/questionarios`,
    GET_TIPO_CONSTRUCAO: '/tipo-construcao',
    GET_BENEFICIARIOS: (idTipoCotacao, codigoAcesso = '') =>
        `/beneficiario?idTipoCotacao=${idTipoCotacao}${codigoAcesso ? '&codigoAcesso=' + codigoAcesso : ''}`,
    GET_DADOS_CO_CORRETAGEM: (codigoCotacao) => `/corretagem?codigoCotacao=${codigoCotacao}`,
    GET_HISTORICO_SIMULACAO: (filter) => `/cotacao-historico/simulacoes?${generateQueryParams(filter)}`,
    GET_HISTORICO_SOLICITACOES: (filter) => `/cotacao-historico/solicitacoes?${generateQueryParams(filter)}`,
    GET_HISTORICO_ACESSO: (codigoAcesso, chaveSegMais, chaveBroto) =>
        `/cotacao-historico/acesso?${generateQueryParams({ codigoAcesso, chaveSegMais, chaveBroto })}`,
    ESCONDER_COTACAO_HISTORICO: (codCotacao) => `/cotacao-historico/esconder/${codCotacao}`,
    GET_DADOS_COMPLETO_COTACAO: (codCotacao) => `/cotacao-historico/completa/${codCotacao}`,
    SEND_LISTA_BENS: (codCotacao) => `/cotacao/${codCotacao}/bens`,
    GET_VIGENCIA_POR_COD_COTACAO: (codCotacao) => `/codigo-acesso/vigencia/${codCotacao}`,
    GET_VIGENCIA_POR_TIPO_COTACAO: (tipoCotacao) => `/tipo-cotacao/vigencia/${tipoCotacao}`,
    GET_POLIGONOS: (codigoCotacao) => `/poligonos/${codigoCotacao}`,
    REMOVE_POLIGONOS: (codigoCotacao, idFront) => `/poligonos/${codigoCotacao}?idFront=${idFront}`,
    SET_POLIGONOS: '/poligonos',
    COTACAO_ATUALIZAR_ANO_BEM: (codigoCotacao) => `/cotacao/${codigoCotacao}`,
    EMAIL_PDF: (codigoCotacao) => `/email-pdf/simulacao/${codigoCotacao}`,
    GET_TEXTO_TOOLTIP: '/relacao-cobertura/texto-tooltip',
    GET_LISTA_COMBOS: (codigoCotacao) => `cotacao/${codigoCotacao}/lista-parcelamento`,
    GET_LISTA_BENS: (numeroApoliceAnterior) => `cotacao/bens/${numeroApoliceAnterior}`,
    GET_DESCONTO_AGRAVO_CODIGO_ACESSO: (codigoAcesso, produto, idsBem) =>
        `desconto-agravo/codigo-acesso/${codigoAcesso}/?idProduto=${produto}&${generateQueryParamsFromList(
            idsBem,
            'idsBem'
        )}`,
    GET_DESCONTO_AGRAVO_TIPO_COTACAO: (idTipoCotacao, produto, idsBem) =>
        `desconto-agravo/tipo-cotacao/${idTipoCotacao}/?idProduto=${produto}&${generateQueryParamsFromList(
            idsBem,
            'idsBem'
        )}`
};

export default ENDPOINTS;
